import axios from "axios";
import { getUsername } from "Common/Components/getRoleId";
import { createContext, useContext, useState, useEffect } from "react";

interface ChildrenProps {
  children: React.ReactNode;
}

interface ContextValue {
  userInfo: any;
  userId: any;
  loading: boolean;
  error: string | null;
  refreshUserInfo: () => Promise<void>;
}

const MyContext = createContext<ContextValue | undefined>(undefined);

export const MyProvider = ({ children }: ChildrenProps) => {
  const [userInfo, setUserInfo] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const token = localStorage?.getItem("app_atkey");
  const userId = getUsername(token);

  const fetchUserInfo = async () => {
    
    if (!userId || !token) {
      setLoading(false);
      setError("User not authenticated");
      return;
    }
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.havirkesht.ir/users/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUserInfo(response.data);
      setError(null);
    } catch (err) {
      setError("Failed to fetch user data");
      console.error("Error fetching user info:", err);
    } finally {
      setLoading(false);
    }
  };
  // دریافت اولیه داده‌ها
  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <MyContext.Provider 
      value={{ 
        userInfo, 
        loading,
        error,
        refreshUserInfo: fetchUserInfo ,
        userId
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => {
  const context = useContext(MyContext);
  if (!context) {
    throw new Error("useMyContext must be used within a MyProvider");
  }
  
  // اینجا می‌توانید بررسی کنید اگر داده‌ها منقضی شده‌اند، مجدداً دریافت کنید
  // یا هر منطق دیگری که نیاز دارید
  
  return context;
};